// const HTTP_ERROR_STATUS = 500;
const HTTP_SUCCESS_STATUS = 200
const HTTP_UNAUTHORIZED_STATUS = 401
// const HTTP_NOT_FOUND_STATUS = 404;

// import Vue from 'vue';
import ApiService from './api.service'
import TokenService from '@/scripts/services/base/token.service'
import Router from '@/router/index'
import CommonHelper from '@/scripts/helpers/common.helper'
import Routes from '@/router/names.js'
import store from '@/store/store'


export default class BaseService {
    constructor(controllerName) {
        this.controllerName = controllerName + '/'
        this.router = Router
    }

    verifyIfTokenIsValid() {
        let meta = this.router.currentRoute.meta;
        // Verifica se o usuário já logou, caso não a verificação não é feita.
        let token = TokenService.getToken();
        if (!token) return;
        
        //Verifica se é uma área do site conselho ou do site admin caso seja do site e valida se o usuário pode navegar pela página.
        let isAgent = TokenService.getIsAgent();
        if((meta.isCouncilUrl == true && isAgent == false) || (meta.isCouncilUrl == false && isAgent == true)) {
            let route = this.router.app.$route;
            if (route.params && route.params.councilId)
                this.router.push({ name: Routes.web.LoginCouncil });
            else 
                this.router.push({ name: Routes.web.Login });
        }
    }

    hideLoader() {
        store.commit('SET_LOADER', false)
    }

    showLoader() {
        store.commit('SET_LOADER', true)
    }

    swal(title, message, type) {
        CommonHelper.swal(title, message, type)
    }

    handleError(baseResponse, showMessage) {
        if (baseResponse && baseResponse.errorMessage) {
            if (showMessage) {
                this.swal(
                    'Desculpe, estamos com dificuldades',
                    baseResponse.errorMessage,
                    'error'
                )
            }
        } else {
            if (showMessage) {
                this.swal('Desculpe, houve um erro inesperado.')
            }
        }

        throw baseResponse
    }

    handleSuccess(baseResponse, showMessage) {
        if (baseResponse && baseResponse.customMessage) {
            if (showMessage) {
                this.swal('Sucesso!', baseResponse.customMessage, 'success')
            }
        }
        if (baseResponse) {
            return baseResponse.data
        }
        return null
    }

    handleToken(baseResponse) {
        if (baseResponse && baseResponse.token) {
            TokenService.saveToken(baseResponse.token)
            //store.commit("AUTHENTICATE", true);
        }
    }

    handleReturn(response, showMessage, showLoader) {
        if (showLoader) this.hideLoader()
        if (response.response !== undefined) {
            response = response.response
        }
        if (response.status == HTTP_SUCCESS_STATUS) {
            this.handleToken(response.data)
            return this.handleSuccess(response.data, showMessage)
        } else if (response.status == HTTP_UNAUTHORIZED_STATUS) {
            TokenService.removeToken()
            let route = this.router.app.$route

            console.log("route.name:", route.name);

            if (
                route.name != Routes.web.Login &&
                route.name != Routes.web.LoginCouncil &&
                route.name != Routes.web.Signature 
            ) {
                if (route.params && route.params.councilId)
                    this.router.push({ name: Routes.web.LoginCouncil })
                else 
                   this.router.push({ name: Routes.web.Login })
            }
            //store.commit("AUTHENTICATE", false);
        } else {
            return this.handleError(response.data, showMessage)
        }
    }

    putRequest(action, data, showMessage = true, showLoader = true) {
        this.verifyIfTokenIsValid();
        
        if (showLoader) this.showLoader();

        const url = this.controllerName + action

        return ApiService.put(url, data)
            .then(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
            .catch(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
    }

    postRequest(action, data, showMessage = true, showLoader = true) {
        this.verifyIfTokenIsValid();
        
        if (showLoader) this.showLoader();

        const url = this.controllerName + action

        return ApiService.post(url, data)
            .then(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
            .catch(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
    }

    postFileRequest(action, data, showMessage = true, showLoader = true) {
        this.verifyIfTokenIsValid();

        if (showLoader) this.showLoader();

        return ApiService.postFiles(this.controllerName + action, data)
            .then(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
            .catch(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
    }
    postRequestBlob(action, data, showMessage = true, showLoader = true) {
        this.verifyIfTokenIsValid();

        if (showLoader) this.showLoader();
        let options = {
            method: 'post',
            url: this.controllerName + action,
            data: data,
            responseType: 'blob',
        }
        return ApiService.requestWithOptions(options)
            .then(
                function(response) {
                    this.hideLoader()
                    return response
                }.bind(this)
            )
            .catch(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
    }

    getRequestBlob(action, data, showMessage = true, showLoader = true) {
        this.verifyIfTokenIsValid();
        if (showLoader) this.showLoader();
        let options = {
            method: 'get',
            url: this.controllerName + action,
            params: data,
            responseType: 'blob',
        }
        return ApiService.requestWithOptions(options)
            .then(
                function(response) {
                    this.hideLoader()
                    return response
                }.bind(this)
            )
            .catch(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
    }

    deleteRequest(action, data, showMessage = true, showLoader = true) {
        this.verifyIfTokenIsValid();
        if (showLoader) this.showLoader();

        const url = this.controllerName + action

        return ApiService.delete(url, data)
            .then(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
            .catch(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
    }

    getRequest(action, data, showMessage = true, showLoader = true) {
        this.verifyIfTokenIsValid();
        if (showLoader) this.showLoader();

        const url = this.controllerName + action

        return ApiService.get(url, data)
            .then(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
            .catch(
                function(response) {
                    return this.handleReturn(response, showMessage, showLoader)
                }.bind(this)
            )
    }

    mountRequestData(url, request, response, httpStatusCode) {
        return `New request: ${JSON.stringify({
            url,
            request,
            response,
            httpStatusCode,
        })}`
    }
}
